









































































import Vue, { PropOptions } from 'vue';

import SelectBox from './SelectBox.vue';

export interface ISelectOption {
  text: string;
  value: number;
}

export interface IVariableInput {
  key: string;
  required: boolean;
  options?: ISelectOption[];
  checks?: string[];
  max?: number;
  min?: number;
  type: 'text' | 'number' | 'time' | 'date' | 'radio' | 'select' | 'textarea' | 'password' ;
  name: string;
  placeholder?: string;
  error?: string;
  disabled?: boolean;
  class?: string;
  step?: number;
  sort?: boolean;
  message?: string;
}

export const INPUT_TYPE = {
  TEXT: 'text',
  NUMBER: 'number',
  TIME: 'time',
  DATE: 'date',
  RADIO: 'radio',
  SELECT: 'select',
  TEXTAREA: 'textarea',
  PASSWORD: 'password',
  CHECKBOX: 'checkbox',
};

export const CHECK_TYPE = {
  EMOJI: 'emoji',
  KANA: 'kana',
  DATE: 'date',
  MAIL: 'mail',
  PASSWORD: 'password',
  TEL: 'tel',
};


export namespace VALIDATION.TYPE {
  export const NUMBER = 'number';
  export const STRING = 'string';
  export const BOOLEAN = 'boolean';
  // export const OBJECT = 'object'; todo:Objectがあるなら考える
}


export const REGDIG: any = {
  company: /^(?=.*(株式会社|合同会社|合資会社|合名会社)).*$/,
  email: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
  password: /^([a-zA-Z0-9]{8,})$/,
  kana: /^[ァ-ヴ-ー]+$/,
  address: /(...??[都道府県])((?:旭川|伊達|石狩|盛岡|奥州|田村|南相馬|那須塩原|東村山|武蔵村山|羽村|十日町|上越|富山|野々市|大町|蒲郡|四日市|姫路|大和郡山|廿日市|下松|岩国|田川|大村)市|.+?郡(?:玉村|大町|.+?)[町村]|.+?市.+?区|.+?[市区町村])(.+)/,
  // tel: /(^0(\d{1}[-]?\d{4}|\d{2}[-]?\d{3}|\d{3}[-]?\d{2}|\d{4}[-]?\d{1})[-]?\d{4})$/,
  mobile: /^(070|080|090)-\d{4}-\d{4}$/,
  visa: /4[0-9]{12}(?:[0-9]{3})?/,
  master_card: /5[1-5][0-9]{14}/,
  diners_card: /3(?:0[0-5]|[68][0-9])[0-9]{11}/,
  american_exporess: /3[47]\d{13}/,
  jcb: /(?:2131|1800|35\d{3})\d{11}/,
  tel: /^[0-9\-]+$/,
  birthday: /^[0-9]{4}\-(0[1-9]|1[0-2])\-(0[1-9]|[1-2][0-9]|3[0-1])$/,
  date_ymd: /^20[0-9]{2}\-(0[1-9]|1[0-2])\-(0[1-9]|[1-2][0-9]|3[0-1])$/,
  date: /^(19[0-9]{2}|20[0-9]{2})\-(0[1-9]|1[0-2])\-(0[1-9]|[12][0-9]|3[01])$/,
  number: /^[0-9]+$/,
  time: /\d{2}:\d{2}/,
  day: /^([1-9]|1[0-9]|2[0-8])$/,
};


const REGDIGMESSAGE: any = {
  tel: '半角数字および半角ハイフン形式にしてください。',
  mail: '半角英数字@半角英数字形式にしてください。',
  kana: 'カナ形式にしてください。',
  date_ymd: '正しい日付で入力してください。',
  date: '正しい日付で入力してください。',
  password: '半角大小英数字8文字以上にしてください。',
};

export const EMOJI_RANGES = [
  '\ud83c[\udf00-\udfff]',
  '\ud83d[\udc00-\ude4f]',
  '\ud83d[\ude80-\udeff]',
  '\ud7c9[\ude00-\udeff]',
  '[\u2600-\u27BF]',
];

export interface ISelectOption {
  text: string;
  value: number;
}

export function hasEmoji(value: string, option: string): string {
  if ( option === CHECK_TYPE.EMOJI) {
    const reg = new RegExp(EMOJI_RANGES.join('|'), 'g');
    if (reg.test(value)) {
      return '絵文字の入力はできません。';
    }
  }
  return '';
};

export function checkOption(value: string, option: string): string {
  let reMessage = '';
  try {
    if (REGDIG[option] != null && !REGDIG[option].test(value)) {
      reMessage = REGDIGMESSAGE[option];
    }
  } catch (e) {
    // console.log(e);
    reMessage = 'error';
  }
  return reMessage;
};

export function checkValue(value: any, item: IVariableInput): boolean {
  item.error = '';
  let valuelength = 0;
  const paramType = typeof value;
  switch (paramType) {
    case VALIDATION.TYPE.NUMBER:
      valuelength = 1;
      break;
    case VALIDATION.TYPE.BOOLEAN:
      valuelength = value;
      break;
    case VALIDATION.TYPE.STRING:
      valuelength = [...value].length;
      break;
    default:
      item.error  += '項目が異常です。 ';
      return false;
  }
  // required
  if (item.required && valuelength <= 0) {
    item.error  += '必須項目です。 ';
  }
  // max and min
  if (valuelength > 0) {
    // max
    if (item.max) {
      if (item.max < valuelength) {
        item.error  += `${item.max}文字以下で入力してください。`;
      }
    }
    // min
    if (item.min) {
      if (item.min > valuelength) {
        item.error  += `${item.min}文字以上で入力してください。`;
      }
    }
  }
  // max and min value
  if (item.type) {
    if (item.type === INPUT_TYPE.NUMBER) {
      // max
      if (item.max) {
        if (item.max < value) {
          item.error  += `${item.max}以下で入力してください。`;
        }
      }
      // min
      if (item.min) {
        if (item.min > value) {
          item.error  += `${item.min}以上で入力してください。`;
        }
      }
    }
  }
  // emoji
  item.error += hasEmoji(value, 'emoji');
  if (item.checks && valuelength > 0) {
    for (const check of item.checks) {
      item.error += checkOption(value, check);
    }
  }
  return item.error.length > 0;
}

export function checkValues(values: any, items: IVariableInput[]): number {
  let resulutValidation = 0;
  for (const key of Object.keys(values)) {
    const item = items.filter((v: any) => (v.key === key));
    if (item.length === 1) {
      resulutValidation = checkValue(values[key], item[0]) ? resulutValidation + 1 : resulutValidation;
    }
  }
  return resulutValidation;
};

export default Vue.extend({
  name: 'VariableInput',
  components: {
    SelectBox,
  },
  props: ['value', 'item', 'requiredVisible'],
  data() {
    return {
      data: '',
      checkboxValue: '',
    };
  },
  mounted() {
    this.item.error = '';
    if (this.item.type === INPUT_TYPE.CHECKBOX) {
      this.checkboxValue = this.value;
    }
  },
  methods: {
    onInput(value: any) {
      this.$emit('input', value);
    },
    onRadioInput(value: string) {
      this.$emit('input', Number(value));
    },
    onChange(value: any) {
      checkValue(value, this.item);
    },
    onChangeCheckbox(value: boolean) {
      this.$emit('input', value);
    },
    onSelectChange(value: any) {
      this.$emit('input', value);
    },
    getOptionsText(options: ISelectOption[] , value: number): string {
      let returnText = '';
      for (let i = 0; i < options.length; i++) {
        if (value === options[i].value) {
          returnText = options[i].text;
        }
      }
      return returnText;
    },
  },
});
